import { Link } from 'react-router-dom'
import { Col, Card } from 'react-bootstrap'
import { PlayFill } from 'react-bootstrap-icons'
import { getAlbumUrl } from '../../api/api.cdlbt.co'

const RecordingItem = ({ recording, index, playFn }) => {
  if (!recording) return ''

  const recordingLink = `/recording/${recording.name}`
  const makeLink = `/chassis/${recording.vehicle.chassis.partMake.makeId}`
  const chassisLink = `${makeLink}/${recording.vehicle.chassis.partId}`
  const operatorLink = `/operator/${recording.vehicle.op.opId}`

  return (
    <Col>
      <Card role='card' className={`g-4 border-0 recording-card`}>
        <div className='p-3 pb-0'>
          <Card.Img
            className={`rounded recording-card-img ${
              recording.vehicle.chassis.partMake.makeId
            } ${recording.hd ? 'recording-card-img-hd' : ''}`}
            src={getAlbumUrl(
              recording.vehicle.body.partMake.makeId,
              recording.vehicle.body.partId
            )}
            alt={recording.vehicle.regName}
          />
          {recording.hd ? (
            <div className='fw-bold rounded px-2 ms-2 recording-card-hd'>
              HQ
            </div>
          ) : (
            <></>
          )}
          <button
            className='recording-card-play border-0 p-2 mb-3 me-3 rounded-circle'
            onClick={() => playFn(index)}
          >
            <PlayFill size={36} />
          </button>
        </div>
        <Card.Body>
          <h6 className='mb-1 fw-semibold text-truncate'>
            <Link
              to={chassisLink}
              className='text-body link-underline link-underline-opacity-0 link-underline-opacity-75-hover'
            >
              {recording.vehicle.chassis.partMake?.makeName}{' '}
              {recording.vehicle.chassis.partName}
            </Link>
          </h6>
          <h5 className='mb-0 fw-bold'>
            <Link className='reg'>{recording.vehicle.regName}</Link>
          </h5>
          <small className='d-block text-truncate'>
            {recording.vehicle.op?.opName}

            {recording.vehicle.fleetNo ? ` - ${recording.vehicle.fleetNo}` : ''}
          </small>
        </Card.Body>
      </Card>
    </Col>
  )
}
export default RecordingItem
